import PayHeader from '../../components/PayHeader'
import PayFooter from '../../components/PayFooter'
import { mapGetters, mapMutations } from 'vuex'

const COUNT_DOWN_SECONDS = 180

export default {
  name: 'Login',
  components: { PayHeader, PayFooter },
  data() {
    return {
      userId: '',
      verificationCode: '',
      errorCode: -1,
      countdown: 0,
      sending: false,
      checking: false,
    }
  },
  computed: {
    ...mapGetters([
      'profile',
    ]),
    canObtaining() {
      return this.userId && !this.countdowning && !this.sending
    },
    countdowning() {
      return this.countdown > 0 && !this.sending
    },
    canCheck() {
      return this.userId && this.verificationCode && this.verificationCode.length >= 6 && !this.checking
    },
  },
  watch: {
    countdown: {
      immediate: true,
      handler(newValue = 0, oldValue = 0) {
        if (newValue <= 0) {
          return clearInterval(this.timer)
        } else if (newValue > oldValue) {
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            this.countdown--
          }, 1000)
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'setProfile',
    ]),
    errorMsg(errorCode) {
      switch (errorCode) {
        case 0:
          return this.$t('sent-tip')
        case 1:
          return this.$t('id-help-tip')
        case 2:
          return this.$t('id-vcode-required-tip')
        case 3:
          return this.$t('error-times-tip')
        case 4:
          return this.$t('vcode-error-tip')
        case 5:
          return this.$t('sent-tip')
        default:
          return `Oops! something error, error code is ${errorCode}`
      }
    },
    async sendVerificationCode() {
      try {
        this.sending = true
        const {
          data: {
            error: errorCode = 100,
          },
        } = await this.axios(`/h5pay/sendcode`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: `uid=${this.userId}`
        })
        this.errorCode = errorCode
        if (errorCode > 0) {
          if ([1].includes(errorCode)) {
            this.$refs.userId.select()
          } else if ([4].includes(errorCode)) {
            this.$refs.verificationCode.select()
          } else if (errorCode === 5) {
            this.countdown = COUNT_DOWN_SECONDS
          }
        } else {
          this.countdown = COUNT_DOWN_SECONDS
        }
        return errorCode === 0
      } catch (error) {
        // ignore
      } finally {
        this.sending = false
      }
    },
    async submit() {
      if (!this.canCheck || this.checking) return
      try {
        this.checking = true
        const {
          data: {
            error: errorCode = 100,
            data: profile
          },
        } = await this.axios.get(`/h5pay/check`, {
          params: {
            uid: this.userId,
            code: this.verificationCode
          }
        })
        this.errorCode = errorCode
        if (errorCode > 0) {
          if ([1].includes(errorCode)) {
            this.$refs.userId.select()
          } else if ([4].includes(errorCode)) {
            this.$refs.verificationCode.select()
          }
        } else {
          await this.setProfile(profile)
          clearInterval(this.timer)
          this.countdown = 0
          this.verificationCode = ''
          this.$router.replace({
            name: 'home'
          })
        }
        return errorCode === 0
      } catch (error) {
        // ignore
      } finally {
        this.checking = false
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
